import { Api } from "../api";
import { getCookie } from "../core/utils";

const jwt = getCookie("book-d booking token");

export const getProviderDetailsBySlug = async (slug: string) => {
  const response = await Api.post(
    `/user/service-provider/by_slug`,
    { slug },
    {}
  );

  return response.data?.data;
};

export const getProviderServices = async (id: string) => {
  const response = await Api.post(
    "/business-account/services/all",
    { business_id: id },
    {}
  );

  return response.data?.data;
};

export const getServiceExtras = async () => {
  const response = await Api.get("/service/extras/get", {});

  return response.data?.data;
};

export const getSchedule = async (data: any) => {
  const response = await Api.post("/team-member/schedule/list", data, {});

  return response.data?.data;
};

export const getStats = async (businessId: string) => {
  const response = await Api.post("/review-rating/stats", { businessId }, {});

  return response.data?.data;
};

export const getReviews = async (businessId: string) => {
  const response = await Api.post(
    "/review-rating/get-all-reviews-by-business",
    { businessId },
    {}
  );

  return response.data?.data;
};

export const getPortfolio = async (business_id: string) => {
  const response = await Api.post(
    "/business-account/gallery/list",
    { business_id },
    {}
  );

  return response.data?.data;
};

export const getProfile = async () => {
  const response = await Api.get("/user/profile", {
    headers: {
      "x-access-token": jwt,
    },
  });

  return response.data?.data;
};

export const fetchLeave = async (data: any) => {
  const response = await Api.post("/team-member/leave/list", data, {
    headers: {
      "x-access-token": jwt,
    },
  });

  return response.data?.data;
};

export const getAvailableSlots = async (data: any) => {
  const response = await Api.post("/team-member/available-slots/fetch", data, {
    headers: {
      "x-access-token": jwt,
    },
  });

  return response.data?.data;
};
